import w1 from "../../assets/works/camara_cctv_ekimak.jpg";
import w2 from "../../assets/works/Historia_amaru_condominio.mp4";
import w3 from "../../assets/works/Ekiamk_historia.jpg";
import w4 from "../../assets/works/Historia_KAUA.mp4";
import w5 from "../../assets/works/Expresarte_Fundacion_dame_esos_5.jpg";
import w6 from "../../assets/works/Historias_EKIMAK.mp4";
import w7 from "../../assets/works/Fuencanto_baru.jpg";
import w8 from "../../assets/works/historia_servicio_ekimak.jpg";
import w9 from "../../assets/works/panderitos_guerreras_yurbaco.jpg";
import w10 from "../../assets/works/servicios_ekimak.jpg";
import w11 from "../../assets/works/torta_de_zanahoria.jpg";

export const workstitle = "Diseño de Historias";

export const loading = "Loading...";

export const phoneFrame =
  "https://cdn.pixabay.com/photo/2021/03/03/09/13/phone-6064855_1280.png";

export const workList = [
  {
    url: w1,
  },
  {
    type: "video",
    url: w2,
  },
  {
    url: w3,
  },
  {
    type: "video",
    url: w4,
  },
  {
    url: w5,
  },
  {
    type: "video",
    url: w6,
  },
  {
    url: w7,
  },
  {
    url: w8,
  },
  {
    url: w9,
  },
  {
    url: w10,
  },
  {
    url: w11,
  },
];
